module.exports = __webpack_public_path__ + "img/reviews-image1.dd40cd8a.jpg";